<template lang="pug">
section
  h2.heading Help Resources for User
  br
  section(v-html="helpTemplate")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HelpResources',
  props: ['orgName', 'accessCode', 'telehealthProvider'],
  data() {
    return {
      helpTemplate: ''
    };
  },
  computed: {
    ...mapGetters(['helpResources'])
  },
  methods: {
    ...mapActions(['getPatientHelpResources'])
  },
  mounted() {
    this.getPatientHelpResources({
      orgName: this.orgName,
      accessCode: this.accessCode
    }).then(() => {
      let template = this.helpResources.htmlTemplate;

      this.helpResources.content.forEach(item => {
        // replace string globally
        const regex = new RegExp('{{' + item.target + '}}', 'g');
        template = template.replace(regex, item.replacement);
      });

      // clean up any remaining tags that haven't been replaced
      template = template.replace(/{{.*}}/, '');

      this.helpTemplate = template;
    });
  }
};
</script>
